import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import {accountProps} from "../Accounts/Accounts";
import DotMenu, {MenuOption} from '../DotMenu/DotMenu';
import DisconnectModal from '../DissconnectModal/DissconnectModal';
import AddAccountModal from '../AddAccountModal/AddAccountModal';
import * as Styled from './AccountBoxStyles';
import ConnectNotice from './ConnectNotice';
import googleLogoIcon from '../../../images/googleGLogo.svg';
import TokenStatus from '../TokenStatus/TokenStatus';
import Box from '../../styled/Box';

export interface AccountBoxStandardProps {
  list?: string[];
  service: accountProps;
}

const ConnectButton = ({ service, connectService }: any) => {
  if (!service.connectionLink) {
    return (
      <Button variant="outline-primary" disabled={true} className='CommingSoon'>
        Coming soon
      </Button>
    )
  }

  if (service.shortName === 'gmail' || service.shortName === 'gdrive') {
    return (
      <Styled.GButton onClick={connectService}>
        <div className="logoContainer">
          <img src={googleLogoIcon} alt="Google"/>
        </div>
        <span className="text-center">Connect with Google</span>
      </Styled.GButton>
    )
  }

  return (
    <Styled.StyledLink href={service.connectionLink} onClick={connectService} >
      Connect
    </Styled.StyledLink>
  )
}

const AccountBox = ({ list, service }: AccountBoxStandardProps) => {
  const [isShowModal, setModalShow] = useState(false);
  const [isShowAddAccount, setShowAddAccount] = useState(false);
  const [showAddNew, setShowAddNew] = useState(true);
  const [dotMenuVisible, setDotMenuVisible] = useState(false);
  const [isNoticeOpen, setIsNoticeOpen] = useState(false);
  const [noticeType, setNoticeType] = useState('');
  const [menuOptions, setMenuOptions] = useState<Array<MenuOption>>([{
    label: 'Add Account',
    action: (e:any) => {
      if (service.connectionLink) {
        connectService(e);
      }
    },
  }]);
  const hasDotMenu = service.subs && service.subs.length > 0

  const showDotMenu = () => {
    setDotMenuVisible(true);
  }

  const hideDotMenu = () => {
    setDotMenuVisible(false);
  }

  const openModal = () => {
    if (service.subs && service.subs.length) {
      setShowAddNew(false);
      setShowAddAccount(true);
    }
  }

  const toggleDisconnectModal = () => {
    setModalShow(!isShowModal);
  }

  const connectService = (e:any) => {
    e.preventDefault();
    setShowAddAccount(false);
    setIsNoticeOpen(true);
    setNoticeType(service.shortName);
  }

  const closeGoogleNotice = () => {
    setIsNoticeOpen(false);
    setNoticeType('');
  }

  useEffect(() => {
    if (service.isConnected) {
      const disconnectOption: MenuOption = {
        label: 'Disconnect',
        labelType: 'error',
        action: toggleDisconnectModal,
      }
      setMenuOptions([{
        label: 'Add Account',
        action: connectService,
      }, disconnectOption]);
    }
  }, [service]);

  return (
    <Styled.Container className='HoverAccount' onMouseEnter={showDotMenu} onMouseLeave={hideDotMenu} >
      <Styled.Container className='Wrapper' onClick={openModal}>
        <Styled.StyledImg src={service.icon?.default} alt="Service icon" />
        <Styled.Header3>{service.name}</Styled.Header3>
        {
          service.isConnected ?
            <Box maxWidth={'100%'}>
              {service.indexingAccounts && (
                <Styled.IndexingText>
                  Setting up your account...
                </Styled.IndexingText>
              )}
              <Styled.NameContainer>
                <Styled.AccountName>
                  {service.accountDisplayName}
                </Styled.AccountName>
                <TokenStatus status={service.token_status} item={service} />
              </Styled.NameContainer>
            </Box>
            :
            <ConnectButton service={service} connectService={connectService} />
        }
        <Styled.Container className='DotsToSee'>
          {
            hasDotMenu && <DotMenu options={menuOptions} visible={dotMenuVisible} />
          }
        </Styled.Container>
      </Styled.Container>
      <AddAccountModal isShowAddAccount={isShowAddAccount} platformName={service.name.toLowerCase()}
                       setShowAddAccount={setShowAddAccount} icon={service.icon.default}
                       service={service}
                       showAddNew={showAddNew}
                       onAdd={connectService}
                       dataMultipleAccs={service.subs}
      />
      <DisconnectModal
        service={service}
        isOpen={isShowModal}
        onClose={toggleDisconnectModal}
      />
      <ConnectNotice
        isOpen={isNoticeOpen}
        type={noticeType}
        link={service.connectionLink}
        onClose={closeGoogleNotice}
      />
    </Styled.Container>
  );
}

export default AccountBox;